import React from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell } from "recharts";

function formatNok(n) {
  if (!n && n !== 0) return "";
  if (n >= 1000000) return (n / 1000000).toFixed(1) + " MNOK";
  if (n >= 1000) return Math.round(n / 1000) + "k";
  return n.toString();
}

export default function RevenueChart({ data, height = 220 }) {
  if (!Array.isArray(data) || data.length === 0) return null;
  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 12, right: 8, left: 0, bottom: 4 }}>
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748B", fontSize: 12, fontFamily: "DM Sans" }}
          />
          <YAxis
            tickFormatter={formatNok}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#94A3B8", fontSize: 11, fontFamily: "DM Sans" }}
            width={44}
          />
          <Tooltip
            cursor={{ fill: "rgba(15,23,42,0.04)" }}
            contentStyle={{
              background: "#0F172A",
              border: "none",
              borderRadius: 10,
              color: "#F8FAFC",
              fontSize: 12,
              padding: "8px 12px",
            }}
            labelStyle={{ color: "#94A3B8", fontSize: 11, marginBottom: 2 }}
            formatter={(v) => [`${v.toLocaleString("nb-NO")} kr`, "Omsetning"]}
          />
          <Bar dataKey="amount" radius={[6, 6, 0, 0]}>
            {data.map((_, i) => (
              <Cell key={i} fill="#0F172A" />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
